/**
 * Cleans and customizes Marketo form styles inside a specified container.
 *
 * - Removes inline styles from all elements (except those with a `data-title` attribute)
 * - Removes specific default Marketo CSS classes from all descendants
 * - Sets form width to 100%
 * - Replaces the default Marketo button class with a custom 'register' class
 *
 * @param {string} containerId - The ID of the container element wrapping the Marketo form
 */

export default function cleanMktoStyles(containerId) {
  const root = document.getElementById(containerId);
  if (!root) return;

  const blacklist = [
    'mktoOffset',
    'mktoGutter',
    'mktoField',
    'mktoTextField',
    'mktoFieldWrap',
    'mktoFormCol',
    'mktoButtonRow',
    'mktoHasWidth',
  ];

  root.querySelectorAll('*').forEach((el) => {
    if (!el.dataset.title) {
      el.removeAttribute('style');
    }

    blacklist.forEach((cls) => el.classList.remove(cls));
  });

  const form = root.querySelector('.mktoForm');
  if (form) form.style.width = '100%';

  const button = root.querySelector('.mktoForm button');
  if (button) {
    button.classList.remove('mktoButton');
    button.classList.add('register');
  }
}
